import React from 'react';
import Title from '../../Common/title';
import Column from '../../../Column';
import { Grid, Typography, useTheme } from '@mui/material';
import ProfileImage from '../../../ProfileImage';
import { colors } from '../../../../utils/palette';
import { SquaredBoxCenteredContent } from '../../../../style/common';

export interface ImageElement {
  src: string;
  imgWidth?: number;
  imgHeight?: number;
  cornerRadius?: number;
  onEmpty?: React.JSX.Element;
}

export interface ImagesProps {
  type: 'imageDetail';
  images: ImageElement[];
  title?: string;
  max_elements?: number;
}

const Images: React.FC<ImagesProps> = ({ title, images, max_elements }) => {
  const theme = useTheme();
  const limit = max_elements !== undefined ? (max_elements > 0 ? max_elements : 1) : images.length;
  const maxElementsArray = limit ? [...images].splice(0, limit) : images;

  return (
    <Column>
      <>
        {title && <Title value={title} />}
        <Grid container style={{ display: 'flex', gap: theme.spacing(1), paddingTop: 0 }}>
          {maxElementsArray.length > 0 &&
            maxElementsArray.map((e) => {
              if ('src' in e) {
                // If e is a string it renders an image
                return (
                  <ProfileImage
                    key={e.src}
                    src={e.src}
                    imgWidth={e.imgWidth ?? 32}
                    imgHeight={e.imgHeight ?? 32}
                    noSkeletonMargin
                    cornerRadius={e.cornerRadius ?? 0}
                    onEmpty={e.src === '-' ? (e.onEmpty ?? <span>-</span>) : (e.onEmpty ?? undefined)}
                  />
                );
              }
            })}
          {limit > 0 && images.length > limit && (
            <SquaredBoxCenteredContent
              style={{
                backgroundColor: colors.lightSecondary,
                color: theme.palette.text.secondary,
              }}
              component="div"
            >
              <Typography style={{ height: '20px', fontWeight: '600', fontSize: '14px' }}>+{images.length - limit}</Typography>
            </SquaredBoxCenteredContent>
          )}
          {maxElementsArray.length === 0 && <span style={{ minHeight: 32 }}>-</span>}
        </Grid>
      </>
    </Column>
  );
};

export default Images;
